import React, { useEffect } from "react"
import DocumentMeta from "react-document-meta"
import { useNavigate, Link } from "react-router-dom"
import AccordionItem from "../components/elements/AccordionItem"
import Header from "../components/Header"
import Footer from "../components/Footer"

function Imprint() {
	const navigate = useNavigate()

	// SEO Meta Tags

	const meta = {
		// title: "Mit merci zum Muttertag filmreif Danke sagen!",
		// canonical: "https://arvato-hawaiian-tropic-2023.de/",
		// meta: {
		// 	name: {
		// 		robots: "noindex, nofollow",
		// 	},
		// },
	}

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<DocumentMeta {...meta}>
			<div className="light bg-cover">
				<Header type="logo" />
				<div className="text-back  mx-auto  py-8 ">
					<div className=" bg-[url(/src/bgimages/form-bg.png)] bg-cover py-8">
						<h2 className="h2 mb-8 mt-12 text-center font-Alpro text-2xl text-white lg:mt-24">Impressum </h2>
					</div>
					<div className="container max-w-[90%] md:max-w-[800px] mx-auto text-center">
						<p className="mb-10 mt-12 text-[18px] md:text-[24px] text-blue" ><strong>Danone Deutschland GmbH</strong><br />
							Am Hauptbahnhof 18<br />
							60329 Frankfurt<br />
							Deutschland<br />
						</p>
						<p className="mb-10 text-blue text-[18px] md:text-[24px]" >
							Tel.: +49 8962 733-0<br />
							E-Mail: pressestelle@danone.com<br />
							Kundenservice: kundenservice@alpro.com<br />
							Registergericht: Amtsgericht Frankfurt am Main<br />
							Registernummer: HRB 112989<br />
						</p>
						<p className="mb-10 text-blue text-[18px] md:text-[24px]" >
							<strong>Geschäftsführung:</strong><br />
							Richard Trechman<br />
							Marc Widmer<br />
							Vorsitzende des Aufsichtsrats:<br />
							Corinna Ortner<br />
							USt-ID: DE175657037<br />
						</p>
						<div className="text-center text-xl text-blue">
							<Link
								to="/"
								className="mb-6 mt-12 block w-[100%] bg-blue p-4 font-Alpro text-[24px] font-bold uppercase tracking-wider text-white drop-shadow-md sm:w-[auto] md:text-[32px] trackind-wider rounded-full border-[3px] border-white lg:inline-block lg:py-2 lg:px-6"
							>
								Zurück
							</Link>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</DocumentMeta>
	)
}
export default Imprint
